import { type TilePos } from '@veriverse/game-logic';
import { regionAt, type Region } from '@veriverse/map-format';
import { TILE_SIZE } from '@veriverse/shared';

/** Camera bounds in pixels. */
export interface CameraBounds {
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
}

/**
 * Where the camera may look (ADR-0037): the region the player stands in, so a map holding two
 * offices only ever shows the current one. The whole map when there are no regions or the player
 * is outside all of them.
 */
export function cameraBounds(
  regions: readonly Region[],
  tile: TilePos,
  mapWidth: number,
  mapHeight: number,
): CameraBounds {
  const region = regionAt(regions, tile);
  if (!region) return { x: 0, y: 0, width: mapWidth * TILE_SIZE, height: mapHeight * TILE_SIZE };
  return {
    x: region.x * TILE_SIZE,
    y: region.y * TILE_SIZE,
    width: region.width * TILE_SIZE,
    height: region.height * TILE_SIZE,
  };
}

export const sameBounds = (a: CameraBounds | undefined, b: CameraBounds): boolean =>
  a !== undefined && a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
